import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pdf-receipt',
  templateUrl: './pdf-receipt.component.html',
  styleUrls: ['./pdf-receipt.component.less']
})
export class PdfReceiptComponent implements OnInit {

  @Input('receiptData') data: any;
  @Output() outToParent = new EventEmitter<string>()
  
  constructor() { }

  ngOnInit() {
    console.log(this.data.length)
    console.log(this.data)
  }

  ngAfterViewInit(){
    this.outToParent.emit("success")
  }

}
